import axios from 'axios';
import ServerProperties from '../../config/server.js'
import {RequestinProcess,SuperADODB} from '../../helper/request.action.js'
export default {
  ReadAsMaster: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      ServerProperties.ATM_CLOUD.API+'Master/Vendor-Master/',
      {
      }
    )
    .then(function (response) {
      // console.log(response);
      // params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(SuperADODB("MasterVendorSetRS",{next:null,previous:null,rs:response.data,query:''}))
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      // params.onfailed(error.response.data)
    });
  },
}



// WEBPACK FOOTER //
// ./src/App/master/vendor/model.js